export default {
    stats: require('./stats'),
    navigation: require('./navigation'),
}



// WEBPACK FOOTER //
// ./src/app/i18n/de/translations.js